import * as styles from "./BillingTab.css";
import * as layout from "./MainInformations.css";

import { clsx } from "clsx";
import { useAtomValue } from "jotai";
import type { JSX } from "react";

import { projectEditorAtom } from "../stores/editor";
import { PaymentTermsSection, RecipientSection } from "./BillingSection";
import { ExpensesSection } from "./ExpensesSection";
import { GroupingSection } from "./GroupingSection";
import { MentionsSection } from "./MentionsSection";
import { ProvenanceSection } from "./ProvenanceSection";
import { QuotationSection } from "./QuotationSection";

/**
 * The short fields in two columns, then the two texts side by side taking
 * whatever height the panel has left.
 */
export function BillingTab(): JSX.Element {
  const { type } = useAtomValue(projectEditorAtom);

  const subscription = "subscription" === type;

  return (
    <div className={clsx(layout.tab, styles.fill)}>
      <div className={layout.top}>
        <div className={layout.column}>
          <PaymentTermsSection />
        </div>

        <div className={layout.column}>
          <RecipientSection />
        </div>
      </div>

      <div className={layout.top}>
        <div className={layout.column}>
          {subscription ? <ProvenanceSection /> : <QuotationSection />}
        </div>

        <div className={layout.column}>
          {subscription ? <GroupingSection /> : <ExpensesSection />}
        </div>
      </div>

      <MentionsSection />
    </div>
  );
}
